export enum CommentType {
    CreateComment,
    EditComment,
    CreateSubComment,
    EditSubComment,
}
